import { Stack } from '@mui/material';
import { SimpleToggle } from 'Components/SimpleToggle';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useContext, useEffect, useState } from 'react';
import { DateRange } from './DateRange';
import { YearRange } from './YearRange';
import { AdvancedSearchContext } from 'Context/MedicalReferralsContext/AdvancedSearchProvider';

export const DateFilter = () => {
  const isDesktop = useIsDesktop();
  const [dateRangeNotYear, setDateRangeNotYear] = useState<boolean>(true);
  const { advancedSearch } = useContext(AdvancedSearchContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.MedicalReferrals)
    .search.advancedSearch;

  useEffect(() => {
    setDateRangeNotYear(!advancedSearch.dateRange.isYear);
  }, [advancedSearch.dateRange.isYear]);

  return (
    <Stack
      direction={isDesktop ? 'row' : 'column'}
      height={'auto'}
      gap={isDesktop ? '48px' : '24px'}
      position={'relative'}
    >
      <SimpleToggle
        option1={dictionary.dateRange}
        option2={dictionary.accordingToYear}
        setState={setDateRangeNotYear}
        isOption2={advancedSearch.dateRange.isYear}
      />
      {dateRangeNotYear ? (
        <Stack
          direction={isDesktop ? 'row' : 'column'}
          gap={'16px'}
          position={'relative'}
          top={'-4px'}
        >
          <DateRange />
        </Stack>
      ) : (
        <YearRange />
      )}
    </Stack>
  );
};
